import type { ProjectRecord } from "../../shared/models";

export interface SelectedCrewMember {
  user_id: number;
  name: string;
  email: string;
  phone: string | null;
  roles: string[];
  project_name: string | null;
}

interface SelectedCrewTrayProps {
  items: SelectedCrewMember[];
  projects: ProjectRecord[];
  selectedProjectId: string;
  selectedProjectName: string | null;
  onProjectChange: (value: string) => void;
  onRemove: (user_id: number) => void;
  onClear: () => void;
  onExportCsv: () => void;
  onExportPdf: () => void;
}

export function SelectedCrewTray({
  items,
  projects,
  selectedProjectId,
  selectedProjectName,
  onProjectChange,
  onRemove,
  onClear,
  onExportCsv,
  onExportPdf,
}: SelectedCrewTrayProps) {
  return (
    <section className="panel selected-crew-tray">
      <div className="selected-crew-header">
        <div>
          <h3>Selected Crew</h3>
          <p className="muted">{items.length} selected for export or print.</p>
        </div>
        <div className="selected-crew-actions">
          <button type="button" className="ghost" onClick={onClear} disabled={items.length === 0}>Clear</button>
          <button type="button" className="ghost" onClick={onExportCsv} disabled={items.length === 0}>Export CSV</button>
          <button type="button" onClick={onExportPdf} disabled={items.length === 0}>Print / PDF</button>
        </div>
      </div>

      <div className="selected-crew-controls">
        <label>
          Project for export
          <select value={selectedProjectId} onChange={(event) => onProjectChange(event.target.value)}>
            <option value="">No shared project</option>
            {projects.map((project) => (
              <option key={project.id} value={project.id}>{project.name}</option>
            ))}
          </select>
        </label>
      </div>

      {items.length === 0 ? (
        <p className="muted">Select crew from Find Crew or Team Calendar to build a roster.</p>
      ) : (
        <div className="selected-crew-list">
          {items.map((item) => (
            <article key={item.user_id} className="selected-crew-card">
              <div>
                <strong>{item.name}</strong>
                <div className="tag-row">
                  {item.roles.map((role) => (
                    <span key={role} className="tag neutral">{role}</span>
                  ))}
                </div>
                <div className="selected-crew-contact-row">
                  <a href={`mailto:${item.email}`}>{item.email}</a>
                  <a href={`tel:${item.phone ?? ""}`}>{item.phone ?? "No phone"}</a>
                </div>
                <p className="muted">Project: {selectedProjectName ?? item.project_name ?? "Not set"}</p>
              </div>
              <button type="button" className="ghost compact-button" onClick={() => onRemove(item.user_id)}>Remove</button>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
